export const dataHooks = {
    filledStar: 'filled-star',
    emptyStar: 'empty-star',
    ratingCaption: 'rating-caption',
};
export const starRatingBarSizes = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const starIndexes = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
};
export const starRatingBarSizesInPx = {
    tiny: 12,
    small: 18,
    medium: 24,
    large: 36,
};
//# sourceMappingURL=constants.js.map